const MEDICATION_MAIL_FEE = 900
const MEDICATION_MAIL_HELP_URL =
  'https://anamne.wraptas.site/a3c9ec905cbc4fdaa43e37314886ce3e'

type Props = {
  className?: string
  // お届け目安。土日診察は週末用の日数に差し替わる (#1192)
  deliveryEstimate?: string
}

export default function MedicationMailNotice({
  className = '',
  deliveryEstimate = '最短当日〜翌々日',
}: Props) {
  return (
    <div
      className={`rounded-md bg-[#F4FAFE] p-3 text-[12px] font-medium text-[#2a3039] ${className}`}
    >
      <p>
        ●「おくすりおうち便」をご利用の場合、配送料として{MEDICATION_MAIL_FEE}円が別途かかります。
      </p>
      <p className="mt-1">
        ●お薬のお届け目安は{deliveryEstimate}です。配送状況により前後する場合があります。
      </p>
      <p className="mt-2 flex items-center gap-1 text-[#2196F3]">
        <svg
          className="h-3.5 w-3.5 shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <a
          href={MEDICATION_MAIL_HELP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          おくすりおうち便の流れ
        </a>
      </p>
    </div>
  )
}
